import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

import { TimeOff } from "@hubcapp/types";

import cancelTimeOff from "../graph-ql/cancelTimeOff.graphql";

const useMutationCancelTimeOff = (
  opts: MutationHookOptions<{
    cancelTimeOff: TimeOff;
  }> = {},
) => useMutation(cancelTimeOff, opts);

export default useMutationCancelTimeOff;
